<template>
    <div>

        <!-- URGENT POPUP -->
        <v-layout  row justify-center>
            <v-dialog  v-model="mustShowAssessmentNoAvailablePopup" persistent max-width="600">
                <v-card class="no-padding no-assessment-popup">
                    <v-card-text class="text-center">
                        <div style="margin: 40px 0 15px">
                            <expired-document></expired-document>
                        </div>


                        <div class="description">
                            <h2 class="color-primary"
                                v-html="text('api.chatbot.expired.assessment.warning.title')">
                            </h2>
                            <p v-html="text('api.chatbot.expired.assessment.warning.details')">
                            </p>
                        </div>

                    </v-card-text>

                    <v-card-actions class="text-center">
                        <v-btn
                                block
                                @click="closeAssessmentNoAvailablePopup()"
                               flat round
                               class="text-transform-none color-primary component-bg-color no-border">
                            {{text('api.chatbot.expired.assessment.warning.ok')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from 'vuex';
    import expiredDocument from "../../../common/components/svg/shared/expiredDocument";

    export default {
        name: 'AssessmentNoAvailablePopup',
        components: {
            expiredDocument
        },

        computed: {
            ...mapGetters({
                mustShowAssessmentNoAvailablePopup: 'ChatBotStore/getMustShowAssessmentNoAvailablePopup',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            })
        },
        mounted() { },
        methods: {
            closeAssessmentNoAvailablePopup() {
                this.$store.commit('ChatBotStore/setMustShowAssessmentNoAvailablePopup', false);
            },
        },

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .close-warning {

        padding-bottom: 50px;



        span {

            float: right;
            padding: 10px;

            .icon {
                color: $color-gray;
            }

            &:hover {
                cursor: pointer;
            }
        }


    }

    .no-assessment-popup {
        min-height: 300px !important;
    }

</style>




// WEBPACK FOOTER //
// src/pathfinder/components/shared/AssessmentNoAvailablePopup.vue